const ref = {
    ownershipRights: [
        {code: 'permanent', label: 'Эгалик(Доимий)'},
        {code: 'temporary_use', label: 'Вақтинчалик фойдаланиш'},
        {code: 'rental_agreement',label: 'Ижара ҳуқуқи'}
    ],
    financialConditions: [
        {code: 'market', label: 'Бозор шартлари'},
        {code: 'non_market', label: 'Бозордан фарқли шартлар'}
    ],
    termsOfSales: [
        {code: 'contract', label: '100% олдиндан тўлов'},
        {code: 'non_contract', label: 'Бўлиб тўлаш'}
    ],
    afterSales: [
        {code: 'exists', label: 'Мавжуд'},
        {code: 'non_exists', label: 'Мавжуд эмас'}
    ],
    economicClassifications: [
        {code: 'high', label: 'Юкори'},
        {code: 'middle', label: 'Ўрта'},
        {code: 'low', label: 'Паст'}
    ],
    activityChangeabilityTypes: [
        {code: 'accommodation', label: 'Турар'},
        {code: 'notorious', label: 'Нотурар'}
    ],
    activityChangeabilityTypesBuilding: [
        {code: 'high', label: 'Юкори'},
        {code: 'middle', label: 'Ўрта'},
        {code: 'low', label: 'Паст'}
    ],
    engineerCommunications: [
        {code: 'all', label: 'Барча'},
        {code: 'some', label: 'Айрим'},
        {code: 'non_exists', label: 'Мавжуд эмас'}
    ],
    autoTransportPlaceState: [
        {code: 'exists', label: 'Мавжуд'},
        {code: 'non_exists', label: 'Мавжуд эмас'}
    ],
    autoTransportPlaceCloseness: [
        {code: 'high', label: 'Юкори(хамма турдаги автотранспортлар)'},
        {code: 'middle', label: 'Ўрта(хамма турдаги автотранспортлар)'},
        {code: 'low', label: 'Паст(хамма турдаги автотранспортлар)'}
    ],
    constructiveElements: [
        {code: 'brick_baked', label: 'Пишиқ ғишт (оҳак ғишт),бетон,шлакоблок'},
        {code: 'brick_crude', label: 'Хом ғишт (лойдан)'},
        {code: 'panel_concrete', label: 'Темир бетон панел (металический)'}
    ],
    repairConditions: [
        {code: 'good', label: 'Яхши'},
        {code: 'bad', label: 'Паст'},
        {code: 'excellent', label: 'Ўрта'},
        {code: 'satisfactory',label: 'Қониқарли'},
        {code: 'dissatisfied',label: 'Қониқарсиз'},
        {code: 'wreckage',label: 'Авария холатда'}
    ],
    physicalCharacteristics: [
        {code: 'high', label: 'Юкори'},
        {code: 'middle', label: 'Ўрта'},
        {code: 'low', label: 'Паст'}
    ],
    economicCharacteristics: [
        {code: 'high', label: 'Юкори'},
        {code: 'middle', label: 'Ўрта'},
        {code: 'low', label: 'Паст'}
    ],
    railways: [
        {code: 'exists', label: 'Мавжуд'},
        {code: 'non_exists', label: 'Мавжуд эмас'}
    ],
    elevators: [
        {code: 'exists', label: 'Мавжуд'},
        {code: 'non_exists', label: 'Мавжуд эмас'}
    ],
    walls: [
        {code: 'brick_baked', label: 'Пишиқ ғишт'},
        {code: 'brick_crude', label: 'Хом ғишт'},
        {code: 'panel_concrete', label: 'Темир бетон панел'},
        {code: 'wood', label: 'Ёғоч (дарахт)'},
        {code: 'brick_baked_and_crude', label: 'Пишиқ ғишт ва хом ғишт'}
    ],
    communications: [
        {code: 'central_heating', name: 'Иссиқлик таъминоти', id: 1},
        {code: 'hot_water_supply', name: 'Иссиқ сув таъминоти', id: 2},
        {code: 'sewage', name: 'Канализация', id: 3},
        {code: 'water_supply', name: 'Сув таъминоти', id: 4},
        {code: 'electric_lighting', name: 'Электр энергия таъминоти', id: 5},
        {code: 'gas_supply', name: 'Газ таъминоти', id: 6},
    ],
    houseCovers: [
        {code: 'reinforced_concrete', label: 'Темирбетон'},
        {code: 'wooden', label: 'Ёғоч'},
        {code: 'metallic', label: 'Металл'}
    ],
    repairs: [
        {code: 'authors_project', label: 'Каробка'},
        {code: 'eurorepair', label: 'Евротаъмир'},
        {code: 'needs_repair', label: 'Эски (таъмир талаб)'},
        {code: 'rough_finish', label: 'Косметик'},
    ],
    layoutTypes: [
        {code: 'adjacent', label: 'Галерея туридаги уй'},
        {code: 'small_family', label: 'Оилавий ётоқхона туридаги уй'},
    ],
    bathroomTypes: [
        {code: 'seperated', label: 'Алоҳида'},
        {code: 'combined', label: 'Аралаш'}
    ],
    storeys: getStoreys(),
    floors:  getStoreys()
};

export default ref;

function getStoreys() {

    const maxStorey = 60;
    let storeys = [];
    const floor = {
        value: -1,
        label: '-1 қават'
    };

    storeys.push(floor)

    for (let i = 1; i <= maxStorey; i++) {
        let storey = {
            value: i,
            label: i + ' қават'
        };
        storeys.push(storey)
    }
    return storeys;
}
